export default __webpack_public_path__ + "0de7ea3c5073c0e852b1f4e42ee0e4ac.png";